<template>
  <!-- 질문13~26 -->
  <v-layout flex-fill column class="survey-type-04">
    <div class="subheader">질문을 읽고 두 단어 사이에 <br />나의 생각과 가장 일치하는 곳을 선택해 주세요.</div>
    <div class="question-wrapper">
      <div class="question" v-html="question"></div>
    </div>
    <div class="answer">
      <!--        <v-slider-->
      <!--        v-model="value"-->
      <!--        step="7"-->
      <!--        track-fill-color="transparent"-->
      <!--        thumb-color="#fff"-->
      <!--        ></v-slider>-->
      <!-- min(최소) / max(최대) / step(증감 수치) -->
      <v-slider
          v-model="value"
          step="1"
          min="0"
          max="6"
          track-fill-color="transparent"
          thumb-color="#fff"
          class="unit-slider-bar"
      ></v-slider>
      <div class="slider-values">
        <span class="min" v-html="startReplyNm">
<!--              ({{startScore}})<br>-->
        </span>
        <span class="max" v-html="endReplyNm">
<!--              ({{endScore}})<br>-->
        </span>
      </div>
      <div class="slider-value" v-html="answerText"></div>
    </div>
  </v-layout>
</template>

<script>
import store from '@/store'
import {mixinAuth} from '@/mixins'

export default {
  mixins: [mixinAuth],
  props: ["question", "surveyData", "travelApplStepCd", "memberStepApplCnt"],
  data: () => ({
    value: 3,
    defaultVal: 16,
    // answerArr:[],
    answerScoreArr: [],
    answerReplyArr: [],
    startScore: 0,
    endScore: 0,
    startReplyNm: '',
    endReplyNm: '',
    answer: 0
  }),
  watch: {
    question() {
      this.getTravelReplyList();
    }
  },
  computed: {
    answerText() {
      // let num = (Math.ceil(this.value / this.defaultVal));
      let num = this.value
      console.log("this.answerReplyArr[num]) : " + this.answerReplyArr[num]);
      this.getTravelReplyNo(this.answerReplyArr[num]);
      return this.answerScoreArr[num]
    }
  },
  created() {
    this.getTravelReplyList()
  },
  methods: {
    async getTravelReplyList() {
      console.log('Step 04 - getTravelReplyList Call');
      let params = [
        {'travelApplNo': this.surveyData.travelApplNo},
        {'unitDtlQuesNo': this.surveyData.unitDtlQuesNo}
      ]
      await store.dispatch('getTravelReplyList', this.$_payload('so', params))
        .then(res => {
          console.log('getTravelReplyList : ', res)
          if (res.success) {
            this.answerScoreArr = res.data.map((item) => item.score);
            this.answerReplyArr = res.data.map((item) => item.reply);
            // this.answerArr = res.data;
            this.startScore = res.data[0].score;
            this.endScore = res.data[6].score;
            this.startReplyNm = res.data[0].replyNm;
            this.endReplyNm = res.data[6].replyNm;

            this.getStepLoadData();
          } else {
            console.log(res.msg)
            this.answerScoreArr = ''
          }
        })
        .catch(error => {
          console.error(error)
          this.answerScoreArr = ''
        })
        .finally(() => {
        })
    },
    async getTravelReplyNo(reply) {
      let params = [
        {'travelApplNo': this.surveyData.travelApplNo},
        {'unitDtlQuesNo': this.surveyData.unitDtlQuesNo},
        {'reply': reply}
      ]
      await store.dispatch('getTravelReplyNo', this.$_payload('so', params))
        .then(res => {
          if (res.success) {
            this.$emit('radioChanged', res.data);
          } else {
            console.log(res.msg)
            this.$emit('radioChanged', 0);
          }
        })
        .catch(error => {
          console.error(error)
          this.$emit('radioChanged', 0);
        })
        .finally(() => {
        })
    },
    async getStepLoadData() { // 스텝별 저장 데이터를 가져옴.
      console.log('Step 04 - getStepLoadData Call');
      await store.dispatch('getStepLoadData', this.$_payload('so', [
        {'travelApplNo': this.surveyData.travelApplNo},
        {'unitNo': this.surveyData.unitNo},
        {'unitDtlNo': this.surveyData.unitDtlNo},
        {'unitDtlQuesNo': this.surveyData.unitDtlQuesNo},
        {'memberNo': this.userKey},
        {'travelApplStepCd': this.travelApplStepCd},
        {'memberStepApplCnt': this.memberStepApplCnt}
      ]))
        .then(res => {
          if (res.success) {
            if (res.data.replyYn == null) {
              this.value = 3;
            } else {
              // this.value = res.data.score * this.defaultVal;
              this.value = res.data.score;
            }
            this.answer = res.data.unitDtlReplyNo;
          } else {
            console.log(res.msg)
            this.value = 0;
            this.answer = 0;
          }
        })
        .catch(error => {
          console.error(error)
          this.value = 0;
          this.answer = 0;
        })
        .finally(() => {
        })
    },
  }
}
</script>

<style lang="scss" scoped>
//::v-deep .v-slider--horizontal {
//  margin: 0 5px;
//
//  .v-slider__track-container {
//    height: 10px;
//
//    .v-slider__track-background {
//      border-radius: 5px;
//      background: linear-gradient(to right, #fff, #7260FF) !important;
//      width: 100% !important;
//    }
//  }
//
//  .v-slider__thumb {
//    width: 20px;
//    height: 20px;
//    background: #fff !important;
//    border: 1px solid #CCC !important;
//    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
//
//    &:before {
//      display: none;
//    }
//  }
//
//}
</style>
